import type { FaireProductEntity } from "../../entity_types/product";

export const p_nkqu6jg66a: FaireProductEntity = {
  token: "p_nkqu6jg66a",
  type: "product",
  name: "Slow But Sincere Birthday Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/eebe69dddef1e7b1e98f57b636d561764f01a70401a0a5292b155fd7b14ab75c.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c64bf30025cdc0232674ca831d3089682afb17b850cff972ef82c37a1b2520b.png",
    "https://cdn.faire.com/fastly/4c902cd952891fb303dfd0a7eab3105258d2478c3338b170581a4ed381af2fec.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:47.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
